<template>
	<div class="row">
		<div class="documentation">
			<div class="documentation-container">

				<div id="response_errors" class="response_errors_container" style="display:none"></div>

				<div>

					<nav aria-label="breadcrumb" class="d-none d-xl-block">
						<ol class="breadcrumb">
							<li class="breadcrumb-item"><a href="/docs">Документы</a></li>
							<li class="breadcrumb-item"><a href="/docs-edit">Список документов</a></li>
							<li v-if="type == 'create'" class="breadcrumb-item active" aria-current="page">Добавить новую программу</li>
							<li v-if="type == 'update'" class="breadcrumb-item active" aria-current="page">Редактировать программу</li>
						</ol>
					</nav>
					<div class="title-block">
						<div class="title-block__left">
							<div v-if="type == 'create'" class="title-block__title">
								Добавить новую программу
							</div>
							<div v-if="type == 'update'" class="title-block__title">
								Редактировать программу
							</div>
						</div>
					</div>

					<input type="hidden" id="softwareIdInput" v-model="softwareId">

					<div class="row mb-4">
						<div class="col-12">
							<div class="form-label">Название программы *</div>
							<input type="text" class="form-control" id="softwareNameInput" placeholder="введите название" v-model="softwareName">
						</div>
					</div>

					<div class="row mb-4">
						<div class="col-12">
							<div class="form-label">Описание программы</div>
							<textarea name="" id="softwareDescriptionInput" cols="30" rows="3" class="form-control" placeholder="введите описание" v-model="softwareDescription"></textarea>
						</div>
					</div>

					<input type="hidden" id="softwareClientInput" v-model="softwareClientSelected">
					<div class="row mb-4">
						<div class="col-12">
							<div class="form-label">Выберите клиента *</div>
							<v-select class="no-searchable" v-model="softwareClient"
								:options="clientOptions"
								@option:selected="onClientChange($event)"
								@option:deselected="onClientDelete($event)"
								:deselectFromDropdown="false"
								:multiple="true"
								:clearable="false">
								<template #no-options="{ search, searching, loading }">
									<div class="text-not-found">Не найдено</div>
								</template>
							</v-select>
						</div>
					</div>

					<div class="row mb-4">
						<div class="col-12">
							<div class="form-label">Url программы *</div>
							<input type="text" class="form-control" id="softwareUrlInput" placeholder="введите url" v-model="softwareUrl">
						</div>
					</div>

					<div class="row mb-4">
						<div class="col-12">
							<div class="form-label">Порядок сортировки</div>
							<input type="text" class="form-control" id="softwareSortInput" placeholder="введите порядок сортировки" v-model="softwareSort">
						</div>
					</div>

					<div class="row mb-4">
						<div class="col-12">
							<div class="form-check">
								<input class="form-check-input" type="checkbox" value="" id="softwareVisibleInput" v-model="softwareVisible">
								<label class="form-check-label" for="softwareVisibleInput"> Опубликован</label>
							</div>
						</div>
					</div>

					<div class="d-flex flex-column flex-lg-row justify-content-between">
						<button class="btn mb-2 mb-lg-0 me-lg-auto" @click.prevent="saveSoftware">
							<span>Сохранить</span>
						</button>
						<button class="btn btn-lg btn-outline-dark" @click.prevent="cancel">
							<span>Отменить</span>
						</button>
					</div>

				</div>
			</div>
		</div>
    </div>
</template>

<script>

export default {
    name: "CreateSoftwareDocumentationComponent",

	props: [
        'type',
        'element',
        'elementdetail',
		'clientlist',
    ],

    data: () => {
        return {
            softwareId: '',
            softwareName: '',
            softwareDescription: '',
            softwareClient: [],
            softwareClientSelected: [],
            softwareUrl: '',
            softwareSort: '',
            softwareVisible: true,
            clientOptions: [],
        };
    },

	created() {

		var list = [];
		this.clientlist.forEach(obj => {
			list.push({
				value: obj.id,
				label: obj.name,
			});
		});
		this.clientOptions = list;

    },

    methods: {

		itemGet: async function () {
			this.softwareId = this.elementdetail.id;
			this.softwareName = this.elementdetail.name;
			this.softwareDescription = this.elementdetail.description;
			this.softwareUrl = this.elementdetail.url;
			this.softwareSort = this.elementdetail.sort;
			if(this.elementdetail.clients) {
				this.elementdetail.clients.forEach(client_id => {
					this.clientlist.forEach(obj => {
						if(obj.id == client_id) {
							this.softwareClient.push({
								value: obj.id,
								label: obj.name
							});
							this.softwareClientSelected.push(obj.id);
						}
					});
				});
			}
			this.softwareVisible = (this.elementdetail.visible == 0) ? false : true;
    },

		saveSoftware: function () {
			var softwareData = {
				type: this.type,
				name: document.getElementById('softwareNameInput').value,
				description: document.getElementById('softwareDescriptionInput').value,
				client: document.getElementById('softwareClientInput').value,
				url: document.getElementById('softwareUrlInput').value,
				sort: document.getElementById('softwareSortInput').value,
				visible: document.getElementById('softwareVisibleInput').checked ? 1 : 0,
			};
			if(this.type == 'update') {
				softwareData.id = document.getElementById('softwareIdInput').value;
			}
			axios.post('/docs-edit/software', softwareData)
				.then(res => {
					if(res.data.status == 'error') {
						var error_list = '<h5>При добавлении программы произошли следующие ошибки:</h5><ul>';
						res.data.errors.forEach(error => {
							error_list += '<li>' + error + '</li>'
						});
						error_list += '</ul>';
						document.getElementById('response_errors').innerHTML = error_list;
						document.getElementById('response_errors').style.display = 'block';
						document.getElementById('response_errors').scrollIntoView({behavior: "smooth"});
					} else if(res.data.status == 'ok') {
						document.location = '/docs-edit';
					}
				});
		},

		onClientChange(events) {
			var value = [];
			events.forEach(obj => {
				value.push(obj.value);
			});
			this.softwareClientSelected = value;
		},

		onClientDelete(events) {
			var new_value = [];
			var value = document.getElementById('softwareClientInput').value;
			value = value.split(',');
			value.forEach(id => {
				if(id != events.value) {
					new_value.push(id);
				}
			});
			this.softwareClientSelected = new_value;
		},

		cancel: function () {
			document.location = '/docs-edit';
		},
    },
    mounted() {
		this.itemGet();
    },
};
</script>
